// extracted by mini-css-extract-plugin
export default {"wrapper":"acl_wrapper__HpMUr","header":"acl_header__cFaoV","content":"acl_content__5IAlv"};